import { ProfessionalMatchCentre } from './ProfessionalMatchCentre';

export function MatchCentre() {
  return <ProfessionalMatchCentre />;
}
